import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import {
  PageFilters,
  PageFinancialClosure,
  PageFoodsAndProducts,
  PageIngredients,
  PageIngredientsActions,
  PageMainOffer,
  PageOrderDetails,
  PageOrders,
  PageProductDetails,
} from '@/features';
import { AuthPage } from '@/features/account';
import { Layout } from '@/layouts';
import { NotFoundPage } from '@/pages';
import {
  AUTH_ROUTE,
  FILTER_LABELS_ROUTE,
  FINANCIAL_CLOSURE_ROUTE,
  FOODS_AND_PRODUCTS_ROUTE,
  INGREDIENTS_ROUTE,
  OFFERS_ROUTE,
  ORDERS_ROUTE,
} from '@/routes';
import './App.css';

export const App = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          index: true,
          element: <Navigate to={ORDERS_ROUTE} replace />,
        },
        {
          path: FOODS_AND_PRODUCTS_ROUTE,
          element: <PageFoodsAndProducts />,
        },
        {
          path: `${FOODS_AND_PRODUCTS_ROUTE}/:id`,
          element: <PageProductDetails />,
        },
        {
          path: ORDERS_ROUTE,
          element: <PageOrders />,
        },
        {
          path: `${ORDERS_ROUTE}/:id`,
          element: <PageOrderDetails />,
        },
        {
          path: FINANCIAL_CLOSURE_ROUTE,
          element: <PageFinancialClosure />,
        },
        {
          path: FILTER_LABELS_ROUTE,
          element: <PageFilters />,
        },
        {
          path: OFFERS_ROUTE,
          element: <PageMainOffer />,
        },
        {
          path: INGREDIENTS_ROUTE,
          element: <PageIngredients />,
        },
        {
          path: `${INGREDIENTS_ROUTE}/create`,
          element: <PageIngredientsActions mode="create" />,
        },
        {
          path: `${INGREDIENTS_ROUTE}/:id`,
          element: <PageIngredientsActions mode="edit" />,
        },
        // {
        //   path: MENU_ROUTE,
        //   element: window.ENVIRONMENT === 'development' ? <PageMenu /> : <NotFoundPage />,
        // },
        // {
        //   path: `${MENU_ROUTE}/:id`,
        //   element: window.ENVIRONMENT === 'development' ? <PageMenuDetails /> : <NotFoundPage />,
        // },
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
    {
      path: AUTH_ROUTE,
      element: <AuthPage />,
    },
  ]);
  return (
    <React.Suspense fallback={<div>Loading router...</div>}>
      <RouterProvider router={router} />
    </React.Suspense>
  );
};
